<div>
  <!---------------------------- recherche ---------------------------------->
  <app-search-product (result)="displayResult($event)"></app-search-product>

  <div class="container">
    <!------------------------ title -------------------------->
    <p>
      <a routerLink="/accueil">{{ "Accueil" }}</a>
      <span> > </span> 
      <a *ngIf="displayFournisseurs && !user?.personneMorale" routerLink="/fournisseurs">{{"Fournisseurs"}}</a>
      <a *ngIf="displayAssocies" routerLink="/associes">{{ "Associés" }}</a>
      <span *ngIf="(displayFournisseurs || displayAssocies) && !user?.personneMorale" > > </span>
      <span *ngIf="displayFournisseurs">{{ "Catalogue Fournisseur : " }}{{ rs }}</span>
      <span *ngIf="displayAssocies">{{ "Catalogue Associé : " }}{{ rs }}</span>
      <span *ngIf="displayRecherche">{{ "Recherche " }}</span>
    </p>
    <div>
      <div>
        <div *ngIf="!activeRecherche" style="height: 50px">
          <div *ngIf="displayFournisseurs" class="d-flex justify-content-start flex-row" style="height: 80px;">
            <div>
              <img [src]="logoUrl" height="50" width="50" style="object-fit: contain;" (error)="imgErr=true">
            </div>
            <div class="cf mx-2">
              <p>{{'CATALOGUE FOURNISSEUR :'}}</p>
              <span class="titre">{{rs}} </span>
            </div>
          </div>
          <div *ngIf="displayAssocies" class="d-flex justify-content-around flex-row"
            style="width: 300px; height: 80px;">
            <div style="height: 80px; background-size: cover;">
              <img src="/assets/images/Pas-dimage-disponible.jpg" height="75px" (error)="imgErr=true">
            </div>
            <div class="cf">
              <p>{{'CATALOGUE ASSOCIÉ'}}</p>
              <span class="titre">{{rs}} </span>
            </div>
          </div>
          <div *ngIf="displayRecherche">
            <div class="d-flex align-items-center py-2">
              <img *ngIf="!favoritesView" [src]="logoUrl" width="33" height="33" (error)="imgErr=true">
              <mat-icon *ngIf="favoritesView" class="fav-icon">favorite</mat-icon>
              <span class="titre px-2"> {{titre}} </span>
            </div>
          </div>
        </div>
        <div *ngIf="activeRecherche && recherche" style="height: 50px" class="d-flex align-items-center">
          <p>Votre recherche pour : <span class="search">"{{recherche}}"</span></p>
        </div>
      </div>

      <div class="line my-2"></div>

      <div class="cat-container">
        <!------------------------ filter(s) -------------------------->
        <div class="menu-resp">
          <app-catalogue-menu-resp *ngIf="!fournisseur" [filtres]="filtres" (filterOut)="saveFilter($event)"
            [vueFournisseur]="displayFournisseurs"></app-catalogue-menu-resp>
          <app-catalogue-menu-resp *ngIf="fournisseur" [filtres]="filtres" (filterOut)="saveFilter($event)"
            [vueFournisseur]="displayFournisseurs" [fournisseur]="fournisseur"></app-catalogue-menu-resp>
        </div>
        <div class="menu">
          <app-catalogue-menu *ngIf="!fournisseur" [filtres]="filtres" (filterOut)="saveFilter($event)"
            [vueFournisseur]="displayFournisseurs"></app-catalogue-menu>
          <app-catalogue-menu *ngIf="fournisseur" [filtres]="filtres" (filterOut)="saveFilter($event)"
            [vueFournisseur]="displayFournisseurs" [fournisseurx]="fournisseur"></app-catalogue-menu>
        </div>
        <!------------------------ contenu catalogue -------------------------->
        <div class="content my-2">
          <mat-paginator *ngIf="loaded && displayedProducts.length>0" [length]="paginatorLength"
            [pageSize]="paginatorValues[0]" [pageIndex]="paginatorIndex" [pageSizeOptions]="paginatorValues"
            aria-label="Select page" (page)="paginatorChange($event)">
          </mat-paginator>
          <div *ngIf="loaded && displayedProducts.length==0" class="text-center my-4">Pas de résultat</div>
          <div class="d-flex align-content-around flex-wrap justify-content-around">
            <div class="cat px-2 my-4" *ngFor="let it of displayedProducts">
              <app-produit [product]="it" [champs]="champs"></app-produit>
            </div>
          </div>
          <mat-paginator *ngIf="loaded && displayedProducts.length>0" [length]="paginatorLength"
            [pageSize]="paginatorValues[0]" [pageIndex]="paginatorIndex" [pageSizeOptions]="paginatorValues"
            aria-label="Select page" (page)="paginatorChange($event)">
          </mat-paginator>
          <div *ngIf="productsError" (click)="loadProducts(2)" class="text-center mt-3">
            <button class="btn-primary" mat-raised-button>{{'UNE ERREUR EST SURVENUE, VEUILLEZ RESSAYER EN CLIQUANT ICI'}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- <app-loading-spinner></app-loading-spinner> -->